import React, { Component } from 'react';

import "./pageView.css";
import "./pageView_mb.css";
import axios from "axios"



class PageView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginNav:true,
            isRightUser:false,
            countdown: 0,
            isEnNav:true
        };
        this.userRef = React.createRef();
        this.pwdRef = React.createRef();
        this.iframeRef = React.createRef();
    };
   
    
    componentDidMount() {
        var fun =  (doc, win)=> {
            var docEl = doc.documentElement,
            resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
            recalc =  () =>{
                var clientWidth = docEl.clientWidth; 
                if (!clientWidth) return;
                docEl.style.fontSize = ((clientWidth / 60) < 12 ? 12 : (clientWidth / 60)) + 'px';
            };
            if (!doc.addEventListener) return;
            win.addEventListener(resizeEvt, recalc, false);
            doc.addEventListener('DOMContentLoaded', recalc, false);
            recalc()
        }
        fun(document, window)
    }
   
    componentWillUnmount () {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
   
    
    languageFun = () => () =>{
        this.setState({
            isEnNav: !this.state.isEnNav,
        },()=>{
            if(this.state.isEnNav){
                document.title = 'BioDuro VR panoramic display'
            }else{
                document.title = '保诺桑迪亚VR全景展示'
            }
        })
    }
    inputUserFun = () => () =>{
        if(this.userRef.current.value == 'xiaxc_sy@163.com' || this.userRef.current.value == '2269544378@qq.com' || this.userRef.current.value.indexOf('@bioduro.com') > 2 || this.userRef.current.value.indexOf('@bioduro-sundia.com') > 2){
            this.setState({isRightUser:true})
        }else{
            this.setState({isRightUser:false})
        }
    }
    sendMessageFun = () => () =>{
        if (this.state.countdown > 0) return; // 倒计时中，禁止发送
        this.setState({ countdown: 60 }, () => {
            this.timer = setInterval(() => {
                this.setState(prevState => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.timer);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        });
        axios({
            url: 'https://vr.bioduro.com/server/send_code.php?email=' + this.userRef.current.value,
        }).then(res => {
            if(res.data.status == "success"){
            } else {
                console.error('发送验证码失败', res.data);
            }
        }).catch(err => {
            console.error(err);
        });
    }
    loginFun = () => () =>{
        if(this.pwdRef.current.value.replace(/\s+/g, '').length == 6 && this.state.isRightUser){
            axios({
                url: 'https://vr.bioduro.com/server/verify_code.php?email=' + this.userRef.current.value +'&code=' + this.pwdRef.current.value.replace(/\s+/g, ''),
            }).then(res => {
                if(res.data.status == "success"){
                    this.setState({loginNav:false})
                } else {
                    this.pwdRef.current.value = ''
                    alert(this.state.isEnNav ? 'Please input the correct email code' : '请输入正确的邮箱验证码!')
                }
            }).catch(err => {
                console.error(err);
            });
        }else{
            this.pwdRef.current.value = ''
            alert(this.state.isEnNav ? 'Please input the correct email code' : '请输入正确的邮箱验证码!')
        }
    }
    render() {
      
        return <div className='container' >
            <div style={{display:this.state.loginNav ? 'flex':'none'}} className={this.state.loginNav ? 'loginDiv' : 'loginDiv transition loginDivhide '}>
                <img src='./image/back.jpg' className='backImg'/>
                <div className='center'>
                    <div className='left pc_show'>
                         <img src='./image/111BioDuro_logo_white.png' />
                        <div className='line1'>{this.state.isEnNav ? 'Step Inside Our Jiangsu Campus — Virtually':'保诺桑迪亚VR全景展示'}</div>
                        <div className='line2'>{this.state.isEnNav ? 'Click to explore our Integrated R&D and \n Manufacturing facilities under one roof' :'CRDMO创新平台 科技为根，以诺文本为本'}</div>
                    </div>
                    <div className='right'>
                        <div className='line0 mb_show'>{this.state.isEnNav ? 'BioDuro VR panoramic display' : '保诺桑迪亚VR全景展示'}</div>
                        <div className='line1'>{this.state.isEnNav ? 'Welcome !' : '欢迎登录'}</div>
                        <div className='lineInput'>
                            <img src='./image/usericon.png' />
                            <input type='text'  ref={this.userRef} placeholder={this.state.isEnNav ?  "Need access? Login by email" : "请输入邮箱"} onChange={this.inputUserFun()}/>
                            <div className='btn' style={{display: this.state.isRightUser ? '' : 'none'}} onClick={this.sendMessageFun()}>
                                {this.state.countdown > 0 ? `${this.state.countdown} ${this.state.isEnNav ? 's Try again' : '秒后重试'}` : (this.state.isEnNav ? 'send verification code':'获取验证码')}
                            </div>
                        </div>
                        <div className='lineInput'>
                            <img src='./image/pwdicon.png' />
                            <input type='text' ref={this.pwdRef} placeholder={this.state.isEnNav ?  "Enter the verification code" : "请输入验证码"}/>
                        </div>
                        <div className='line3' onClick={this.loginFun()}>{this.state.isEnNav ? "Login" : "登录"}</div>
                    </div>
                </div>
            </div>
            {
                !this.state.loginNav ? <iframe style={{display:!this.state.loginNav ? 'block':'none'}} ref={this.iframeRef} src='./vr/'></iframe> : <div></div>
            }
            
        </div>
    }
}


export default PageView;
